import * as React from "react";
import { Row, Col } from "@intechprev/componentes-web";
import { Session } from "@intech/react-service";
import { History } from "history";

import { LoginEntidade } from "../../entidades";
import { UsuarioService } from "../../services";
import { PageClean } from "..";

interface Props {
    history?: History;
}

interface State {
    user: LoginEntidade;
    loading: boolean;
    loginFeito: boolean;
    matriculas: Array<any>;
}

export default class SelecionarMatricula extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            user: new LoginEntidade(),
            loading: false,
            loginFeito: false,
            matriculas: [],
        };
    }

    componentDidMount = async () => {
        var matriculas = await UsuarioService.BuscarMatriculas();
        await this.setState({
            matriculas,
        });
    };

    selecionar = async (matricula: string) => {
        var login = await UsuarioService.SelecionarMatricula(matricula);
        await Session.setToken(login.AccessToken);
        await localStorage.setItem("pensionista", login.Pensionista.toString());

        await this.props.history.push("/");
    };

    render() {
        return (
            <PageClean {...this.props}>
                <h5>
                    <b>
                        Encontramos mais de uma matrícula vinculada ao seu CPF.
                        Para entrar no Portal favor selecionar uma opção abaixo:
                    </b>
                </h5>

                <br />
                <br />

                {this.state.matriculas.map((matricula, index) => {
                    return (
                        <Row key={index} className={"mb-3"}>
                            <Col>
                                <div
                                    className="matricula-card"
                                    onClick={() =>
                                        this.selecionar(matricula.Matricula)
                                    }
                                >
                                    <Row>
                                        <Col>
                                            <b>Empresa: </b>
                                            <label
                                                style={{
                                                    fontSize: 15,
                                                }}
                                            >
                                                {matricula.Empresa}
                                            </label>
                                            <br />
                                            <b>Matrícula: </b>
                                            <label
                                                style={{
                                                    fontSize: 15,
                                                }}
                                            >
                                                {matricula.Matricula}
                                            </label>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    );
                })}
            </PageClean>
        );
    }
}
